import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'accredible-mobile-pop-up',
  templateUrl: 'mobile-pop-up.component.html',
  styleUrls: ['mobile-pop-up.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobilePopUpComponent implements OnDestroy {
  private readonly _language: AccredibleLanguageService = inject(AccredibleLanguageService);

  // TODO: cannot switch to viewChild signal due to this ng-mocks bug: https://github.com/help-me-mom/ng-mocks/issues/8634
  @ViewChild(TemplateRef)
  templateRef: TemplateRef<any>;

  headerTemplate = input<TemplateRef<any>>();
  title = input<string>();

  ignoreTheming = input<boolean>(false);

  move = false;

  readonly direction$ = this._language.direction$;
  readonly closed$ = new Subject<void>();

  ngOnDestroy(): void {
    this.closed$.complete();
  }

  closeMenu(): void {
    this.closed$.next();
  }
}
